import React, { useState, useEffect } from 'react'

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg=='

// TypeScript'e fallbackSrc diye bir şeyin gelebileceğini öğretiyoruz
interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string
}

export function ImageWithFallback({ src, fallbackSrc, alt, className, ...props }: ImageWithFallbackProps) {
  // Görüntülenecek kaynak (ilk başta gelen src)
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);
  const [hasError, setHasError] = useState(false);

  // Eğer ana componentten gelen "src" değişirse (örn: başka kullanıcıya geçilirse)
  // state'i sıfırla ve yeni resmi dene.
  useEffect(() => {
    setImgSrc(src);
    setHasError(false);
  }, [src]);

  const handleError = () => {
    // Sonsuz döngüye girmemesi için kontrol
    if (hasError) return;

    setHasError(true);

    // Eğer dışarıdan bir yedek resim (fallbackSrc) gönderildiyse onu kullan,
    // yoksa o gri kutuyu (ERROR_IMG_SRC) kullan.
    if (fallbackSrc) {
      setImgSrc(fallbackSrc);
    } else {
      setImgSrc(ERROR_IMG_SRC);
    }
  }

  return (
    <img
      src={imgSrc || (fallbackSrc || ERROR_IMG_SRC)}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
    />
  );
}